var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LegalPage',{attrs:{"title":"About Us","intro":"gbmodshub.net is an independent information site for Android users who want to understand GB WhatsApp before downloading an APK.","sections":_vm.sections,"email":"contact@gbmodshub.net","page-name":"about"}})
}
var staticRenderFns = []

export { render, staticRenderFns }